import Uppy, { debugLogger } from "@uppy/core";
import Dashboard from "@uppy/dashboard";
import XHRUpload from "@uppy/xhr-upload";

import Svg from "../../../../src/svg";

class UppyUtilities {
  constructor(files = []) {
    this.files = files;
    this.uppyInstance = null;
  }

  setUppyInstance() {
    this.uppyInstance = new Uppy({
      logger: debugLogger,
      autoProceed: true,
      proudlyDisplayPoweredByUppy: false,
      restrictions: {
        allowedFileTypes: ["application/pdf"],
        maxFileSize: 5 * 1024 * 1024,
      },
      locale: {
        strings: {
          failedToUpload:
            "Sorry, we were unable to upload your file. Please try again later.",
        },
      },
    })
      .use(Dashboard, {
        target: ".SubmissionPdfContainer",
        inline: true,
        height: 470,
        metaFields: [
          { id: "name", name: "Name", placeholder: "file name" },
          { id: "caption", name: "Caption", placeholder: "add description" },
        ],
        hideUploadButton: true,
      })
      .use(XHRUpload, {
        endpoint:
          "/dashboard/pdf_extractor/submissions/validate_uploaded_and_selected_pdf",
        headers: {
          "X-CSRF-Token": $.rails.csrfToken(),
        },
        formData: true,
        timeout: 0 // unlimited
      });

    this.fileAdded();
    this.fileRemoved();
    this.uploadSuccess();
    this.uploadError();
    this.complete();

    return this.uppyInstance;
  }

  fileAdded() {
    this.uppyInstance.on("file-added", (file) => {
      this.uppyInstance.setFileMeta(file.id, {
        template_id: document
          .getElementById("pdf_submission_template_id")
          .value.trim(),
      });
    });
  }

  fileRemoved() {
    this.uppyInstance.on("file-removed", (file) => {
      setTimeout(() => {
        this.addIndicatorHandlers(this.files);
      });
    });
  }

  uploadSuccess() {
    this.uppyInstance.on("upload-success", (file, response) => {
      let data = response.body;
      this.files.push({
        id: file.id,
        key: data.key,
        name: data.name,
        content_type: data.content_type,
        submission_json: data.submission_json,
      });
    });
  }

  uploadError() {
    this.uppyInstance.on("upload-error", (file, error, { response }) => {
      alert(JSON.parse(response).message);
      this.uppyInstance.removeFile(file.id);
    });
  }

  complete() {
    this.uppyInstance.on("complete", (result) => {
      this.addIndicatorHandlers(result.successful);
      this.hideDoneButton();
      this.hideRetryButton();
    });
  }

  hideDoneButton() {
    const doneButton = document.querySelector(
      ".uppy-StatusBar-actionBtn--done"
    );

    if (doneButton) {
      doneButton.style.display = "none";
    }
  }

  hideRetryButton() {
    const retryButton = document.getElementsByClassName(
      "uppy-StatusBar-actionBtn--retry"
    )[0];

    if (retryButton) {
      retryButton.style.display = "none";
    }
  }

  addIndicatorHandlers(files) {
    this.setFilesAddedStatus();
    files.forEach((file) => {
      const fileItem = document.getElementById(`uppy_${file.id}`);

      const indicator = fileItem.querySelector(
        ".uppy-Dashboard-Item-progressIndicator"
      );

      const svg = new Svg();
      indicator.addEventListener("click", (event) => {
        let updatedFileValues = this.files;
        let updatedFiles = updatedFileValues.filter(
          (item) => item.id !== file.id
        );
        this.files = updatedFiles;
        this.uppyInstance.removeFile(file.id);
      });

      indicator.addEventListener("mouseenter", (event) => {
        event.target.children[0].innerHTML = svg.cross();
      });

      indicator.addEventListener("mouseleave", (event) => {
        event.target.innerHTML = svg.tick();
      });
    });
  }

  setFilesAddedStatus() {
    document.getElementById("pdf_submission_files_added_status").value =
      this.files.length > 0;
  }
}
export default UppyUtilities;
